import React from 'react'
import Breadcrumb from '../BreadCrumb/BreadCrumb'
import AboutOne from '../container/About/AboutOne'
import HomeContact from '../container/HomeContainer/HomeContact'
import Footer from '../footer/Footer'
import MainNavigation from '../nav/MainNavigation'
import SEO from '../SEO/SEO'

function About() {
    return (
        <React.Fragment>
            <SEO title="Dr Bupathi Gastro and Laparoscopy || About Us" />
            <MainNavigation />
            <Breadcrumb image="/images/pages/about.jpg" title="Home" content="About Us" />
            <AboutOne />
            <HomeContact />
            <Footer />
        </React.Fragment>
    )
}

export default About